import { useParams } from "react-router-dom";
import { TargetedCampaign } from "./TargetedCampaign/TargetedCampaign";
import { View } from "@aws-amplify/ui-react";

export function UpdateTargetedCampaign(props) {
    const { targetedcampaignId } = useParams();
    return (
        <View>
            {/* Removed heading for "Update Targeted Campaign" */}
            <TargetedCampaign {...props} campaignId={targetedcampaignId} />
        </View>
    );
}
